<template>
  <b-container fluid>
    <DynamicComponent v-for="({ __component, ...props }, index) in components" :key="`${__component}-${index}`"
      :type="__component" v-bind="props" :locale="locale" />
  </b-container>
</template>

<script>
import DynamicComponent from '@/components/DynamicComponent'

export default {
  components: {
    DynamicComponent
  },
  props: {
    locale: String,
    label: String,
    components: Array
  },
  metaInfo() {
    return { title: this.label }
  }
}
</script>
